const backendDomain = "https://demo.oakyaitservices.in/api";


const SummaryApi = {
  popupForm: {
    url: `${backendDomain}/mail/mailsend1.php`,
    method: "post",
  },
};

export default SummaryApi;
